<template>
    <v-card class="pa-4 ma-10 elevation-2 mt-10" outlined>
        <v-card-title>Importar Estado de Cuenta</v-card-title>

        <v-card-text>
            <v-form ref="form" @submit.prevent="uploadFile">
                <v-file-input v-model="file" label="Selecciona archivo (.xlsx o .json)" accept=".xlsx,.json" outlined
                    dense prepend-icon="mdi-upload" :rules="[v => !!v || 'Archivo requerido']"></v-file-input>

                <v-btn color="primary" class="mt-3" :disabled="!file || loading" @click="uploadFile">
                    <v-icon left>mdi-cloud-upload</v-icon>
                    Subir archivo
                </v-btn>

                <v-progress-linear v-if="loading" indeterminate color="blue" class="mt-3"></v-progress-linear>

                <v-alert v-if="successMessage" type="success" class="mt-3" dismissible>
                    {{ successMessage }}
                </v-alert>

                <v-alert v-if="errorMessage" type="error" class="mt-3" dismissible>
                    {{ errorMessage }}
                </v-alert>
            </v-form>
        </v-card-text>
    </v-card>

</template>

<script>
import VentaDataService from '@/service/venta/VentaDataService';

export default {
  data() {
    return {
      file: null,
      successMessage: '',
      errorMessage: '',
      loading: false
    };
  },
  methods: {
    async uploadFile() {
      if (!this.file) {
        this.errorMessage = "Selecciona un archivo primero.";
        return;
      }

      this.loading = true;
      this.successMessage = '';
      this.errorMessage = '';

      try {
        const fileName = this.file.name.toLowerCase();

        if (fileName.endsWith('.xlsx')) {
          await VentaDataService.importExcelAccount(this.file); // ✅ class method call
          this.successMessage = 'Archivo Excel importado correctamente.';
        } else if (fileName.endsWith('.json')) {
          const text = await this.file.text();
          const jsonArray = JSON.parse(text);
          await VentaDataService.importJsonAccount(jsonArray); // ✅ class method call
          this.successMessage = 'Archivo JSON importado correctamente.';
        } else {
          throw new Error('Formato no soportado. Solo .xlsx o .json permitidos.');
        }

        this.file = null;
      } catch (err) {
        this.errorMessage = err.message || 'Error al importar archivo.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-card {
    max-width: 600px;
    margin: auto;
}
</style>
